import { z } from 'zod';
import { ExperienceTypeSchema } from '@common/features/DynamicPackagesConfigurationWizard/types';

const SingleSelectedExperienceSchema = z.object({
  type: ExperienceTypeSchema,
  id: z.number(),
  delayAfter: z.number().optional(),
  optionGroupId: z.number().or(z.string()).optional(),
  optionId: z.number().or(z.string()),
  dayNumber: z.number(),
  count: z.number().default(0),
  isIncluded: z.boolean(),
  numberOfGroupSelectionsRequired: z.number().default(1),
  startTime: z.string().optional(),
});
export const SelectExperienceSchema = z.array(SingleSelectedExperienceSchema);

export type SelectedExperienceType = z.infer<typeof SingleSelectedExperienceSchema>;
